(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('reference-header')) {
    class ReferenceHeader extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.categories = this.querySelector('[data-rh-categories]');
        this.searchForm = this.querySelector('[data-rh-search]');
        this.desktopQuery = window.matchMedia('(min-width: 990px)');

        document.addEventListener(
          'click',
          (event) => {
            if (
              this.categories &&
              this.categories.open &&
              !this.categories.contains(event.target)
            ) {
              this.categories.open = false;
            }
          },
          { signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key === 'Escape' &&
              this.categories &&
              this.categories.open
            ) {
              this.categories.open = false;
              this.categories.querySelector('summary').focus();
            }
          },
          { signal }
        );

        this.desktopQuery.addEventListener(
          'change',
          () => {
            if (this.categories) {
              this.categories.open = false;
            }
          },
          { signal }
        );

        if (!this.searchForm) return;

        const input = this.searchForm.querySelector('[name="q"]');
        const vendorSelect =
          this.searchForm.querySelector('[data-rh-vendor]');

        const vendorPattern =
          /^(?:\(([\s\S]*)\) AND )?vendor:"((?:\\.|[^"\\])*)"$/;

        const existingQuery = input.value.trim();
        const existingMatch = existingQuery.match(vendorPattern);

        if (existingMatch && vendorSelect) {
          const existingVendor = existingMatch[2].replace(
            /\\([\\"])/g,
            '$1'
          );

          const matchingOption = Array.from(vendorSelect.options).find(
            (option) => option.value === existingVendor
          );

          if (matchingOption) {
            vendorSelect.value = existingVendor;
            input.value = existingMatch[1] || '';
          }
        }

        this.searchForm.addEventListener(
          'submit',
          (event) => {
            if (!vendorSelect || !vendorSelect.value) return;

            event.preventDefault();

            const term = input.value.trim();

            const vendor = vendorSelect.value.replace(
              /[\\"]/g,
              '\\$&'
            );

            const query = term
              ? `(${term}) AND vendor:"${vendor}"`
              : `vendor:"${vendor}"`;

            const destination = new URL(
              this.searchForm.action,
              window.location.origin
            );

            destination.searchParams.set('type', 'product');
            destination.searchParams.set('options[prefix]', 'last');
            destination.searchParams.set('q', query);

            window.location.assign(destination.toString());
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    }

    customElements.define('reference-header', ReferenceHeader);
  }


  if (!customElements.get('rh-sticky-header')) {
    class RHStickyHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section-header');

        if (!this.section) return;

        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.alwaysSticky =
          this.dataset.stickyType === 'always' ||
          this.dataset.stickyType === 'reduce-logo-size';

        this.lastScrollTop = Math.max(0, window.scrollY);
        this.preventReveal = false;
        this.frame = null;

        this.updateMeasurements();

        this.section.classList.add('rh-is-sticky');

        this.resizeObserver = new ResizeObserver(() => {
          this.updateMeasurements();
        });

        this.resizeObserver.observe(this.section);

        window.addEventListener(
          'resize',
          () => this.updateMeasurements(),
          { signal, passive: true }
        );

        window.addEventListener(
          'scroll',
          () => {
            if (this.frame !== null) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.onScroll();
            });
          },
          { signal, passive: true }
        );

        this.addEventListener(
          'preventHeaderReveal',
          () => {
            this.preventReveal = true;

            clearTimeout(this.revealTimer);

            this.revealTimer = setTimeout(() => {
              this.preventReveal = false;
            }, 120);
          },
          { signal }
        );
      }

      updateMeasurements() {
        if (!this.section) return;

        this.headerHeight = this.section.offsetHeight;

        document.documentElement.style.setProperty(
          '--header-height',
          `${this.headerHeight}px`
        );

        const headerGroup = this.section.parentElement;
        let precedingHeight = 0;

        if (headerGroup) {
          for (const sibling of headerGroup.children) {
            if (sibling === this.section) break;

            const style = getComputedStyle(sibling);

            if (
              style.display !== 'none' &&
              style.position !== 'absolute' &&
              style.position !== 'fixed'
            ) {
              precedingHeight +=
                sibling.getBoundingClientRect().height +
                (parseFloat(style.marginTop) || 0) +
                (parseFloat(style.marginBottom) || 0);
            }
          }
        }

        this.threshold = precedingHeight + this.headerHeight;
      }

      onScroll() {
        if (!this.section) return;

        const scrollTop = Math.max(0, window.scrollY);
        const pastHeader = scrollTop > this.threshold;

        this.section.classList.toggle('rh-scrolled', pastHeader);

        if (this.alwaysSticky) {
          this.lastScrollTop = scrollTop;
          return;
        }

        const menuDrawer = this.querySelector('header-drawer');

        const drawerOpen =
          menuDrawer &&
          menuDrawer.querySelector('details[open]');

        if (drawerOpen) {
          this.section.classList.remove('rh-is-hidden');
          this.lastScrollTop = scrollTop;
          return;
        }

        if (!pastHeader) {
          this.section.classList.remove(
            'rh-is-hidden',
            'rh-can-animate'
          );

          this.lastScrollTop = scrollTop;
          return;
        }

        if (Math.abs(scrollTop - this.lastScrollTop) < 4) {
          return;
        }

        this.section.classList.add('rh-can-animate');

        if (scrollTop > this.lastScrollTop) {
          this.section.classList.add('rh-is-hidden');

          this.querySelectorAll('[data-rh-categories]').forEach(
            (details) => {
              details.open = false;
            }
          );
        } else if (!this.preventReveal) {
          this.section.classList.remove('rh-is-hidden');
        }

        this.lastScrollTop = scrollTop;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();

        clearTimeout(this.revealTimer);

        if (this.frame !== null) {
          cancelAnimationFrame(this.frame);
        }

        this.section?.classList.remove(
          'rh-is-sticky',
          'rh-is-hidden',
          'rh-can-animate',
          'rh-scrolled'
        );
      }
    }

    customElements.define('rh-sticky-header', RHStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-deals"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('hot-deals-carousel')) {

    class HotDealsCarousel extends HTMLElement {

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.track = this.querySelector('[data-hd-track]');
        this.previous = this.querySelector('[data-hd-prev]');
        this.next = this.querySelector('[data-hd-next]');
        this.controls = this.querySelector('[data-hd-controls]');

        if (!this.track) return;

        this.previous?.addEventListener(
          'click',
          () => this.move(-1),
          { signal }
        );

        this.next?.addEventListener(
          'click',
          () => this.move(1),
          { signal }
        );

        this.track.addEventListener(
          'scroll',
          () => this.updateControls(),
          { signal, passive: true }
        );

        this.track.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== this.track) return;

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.move(1);
            }

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.move(-1);
            }
          },
          { signal }
        );

        this.resizeObserver = new ResizeObserver(() => {
          this.updateControls();
        });

        this.resizeObserver.observe(this.track);

        this.updateControls();
      }

      move(direction) {
        const card = this.track.querySelector('.hd-item');

        if (!card) return;

        const gap =
          parseFloat(getComputedStyle(this.track).columnGap) || 0;

        const distance = card.getBoundingClientRect().width + gap;

        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.track.scrollBy({
          left: direction * distance,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      updateControls() {
        if (!this.track || !this.controls) return;

        const maximum =
          this.track.scrollWidth - this.track.clientWidth;

        this.controls.hidden = maximum <= 2;

        if (this.previous) {
          this.previous.disabled = this.track.scrollLeft <= 2;
        }

        if (this.next) {
          this.next.disabled =
            this.track.scrollLeft >= maximum - 2;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    }

    customElements.define('hot-deals-carousel', HotDealsCarousel);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('collection-catalog-layout')) {
    class CollectionCatalogLayout extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();

        this.controller = new AbortController();

        const { signal } = this.controller;
        const shell = this.querySelector('[data-vc-shell]');
        const toggle = this.querySelector('[data-vc-toggle]');
        const toggleLabel = this.querySelector('[data-vc-toggle-label]');

        if (shell && toggle) {
          toggle.addEventListener(
            'click',
            () => {
              const currentlyHidden =
                shell.dataset.filtersHidden === 'true';

              shell.dataset.filtersHidden =
                currentlyHidden ? 'false' : 'true';

              toggle.setAttribute(
                'aria-expanded',
                currentlyHidden ? 'true' : 'false'
              );

              if (toggleLabel) {
                toggleLabel.textContent =
                  currentlyHidden ? 'Hide filters' : 'Show filters';
              }
            },
            { signal }
          );
        }

        const menu = this.querySelector('[data-vc-sort-menu]');
        const select = this.querySelector('#SortBy');
        const valueLabel = this.querySelector('[data-vc-sort-value]');

        if (!menu || !select) return;

        const syncSort = () => {
          const selectedOption = select.options[select.selectedIndex];

          if (valueLabel && selectedOption) {
            valueLabel.textContent =
              selectedOption.textContent.trim();
          }

          menu.querySelectorAll('[data-vc-sort-option]').forEach(
            (button) => {
              button.setAttribute(
                'aria-pressed',
                button.dataset.value === select.value
                  ? 'true'
                  : 'false'
              );
            }
          );
        };

        const closeMenu = (restoreFocus = false) => {
          menu.open = false;

          if (restoreFocus) {
            menu.querySelector('summary')?.focus();
          }
        };

        menu.hidden = false;
        select.closest('form')?.classList.add('vc-sort-enhanced');
        syncSort();

        menu.addEventListener(
          'toggle',
          () => {
            if (menu.open) syncSort();
          },
          { signal }
        );

        menu.addEventListener(
          'click',
          (event) => {
            const option =
              event.target.closest('[data-vc-sort-option]');

            if (!option || !menu.contains(option)) return;

            const changed =
              select.value !== option.dataset.value;

            select.value = option.dataset.value;

            syncSort();
            closeMenu(true);

            if (changed) {
              select.dispatchEvent(
                new Event('input', { bubbles: true })
              );
            }
          },
          { signal }
        );

        select.addEventListener('change', syncSort, { signal });

        document.addEventListener(
          'click',
          (event) => {
            if (menu.open && !menu.contains(event.target)) {
              closeMenu();
            }
          },
          { signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && menu.open) {
              event.preventDefault();
              closeMenu(true);
            }
          },
          { signal }
        );

        window.addEventListener(
          'popstate',
          () => {
            const sortValue =
              new URLSearchParams(window.location.search)
                .get('sort_by');

            const defaultValue =
              Array.from(select.options).find(
                (option) => option.defaultSelected
              )?.value;

            select.value =
              sortValue ||
              defaultValue ||
              select.options[0]?.value;

            syncSort();
          },
          { signal }
        );

        this.observer = new MutationObserver(syncSort);

        this.observer.observe(select, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    }

    customElements.define(
      'collection-catalog-layout',
      CollectionCatalogLayout
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('related-deals-carousel')) {
    class RelatedDealsCarousel extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();

        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.track = this.querySelector('[data-rd-track]');
        this.previous = this.querySelector('[data-rd-prev]');
        this.next = this.querySelector('[data-rd-next]');
        this.controls = this.querySelector('[data-rd-controls]');

        if (!this.track) return;

        this.previous?.addEventListener(
          'click',
          () => this.move(-1),
          { signal }
        );

        this.next?.addEventListener(
          'click',
          () => this.move(1),
          { signal }
        );

        this.track.addEventListener(
          'scroll',
          () => this.updateControls(),
          { signal, passive: true }
        );

        this.track.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== this.track) return;

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.move(1);
            }

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.move(-1);
            }
          },
          { signal }
        );

        this.resizeObserver = new ResizeObserver(() => {
          this.updateControls();
        });

        this.resizeObserver.observe(this.track);

        this.updateControls();
      }

      move(direction) {
        const card = this.track.querySelector('.rd-item');

        if (!card) return;

        const gap =
          parseFloat(getComputedStyle(this.track).columnGap) || 0;

        const distance = card.getBoundingClientRect().width + gap;

        const reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.track.scrollBy({
          left: direction * distance,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      updateControls() {
        if (!this.track || !this.controls) return;

        const maximum =
          this.track.scrollWidth - this.track.clientWidth;

        this.controls.hidden = maximum <= 2;

        if (this.previous) {
          this.previous.disabled =
            this.track.scrollLeft <= 2;
        }

        if (this.next) {
          this.next.disabled =
            this.track.scrollLeft >= maximum - 2;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    }

    customElements.define(
      'related-deals-carousel',
      RelatedDealsCarousel
    );
  }

  } catch(e) { console.error(e); }
})();
})();
